import { log } from '@/logger/logger';
import { getAxiosInstance } from '@/services/axiosConfig';

const logger = log.getLogger('civit.api');
const axiosInstance = getAxiosInstance();

export const getCivitModelVersionsByNumericalId = async (civitModelUrl: string) => {
  const civitId = civitModelUrl.split('/').filter((part) => /^\d+$/.test(part))[0];
  try {
    const res = await axiosInstance.get<{ modelVersions: { id: string }[]; name: string }>(
      `/v1/models/civit/${civitId}`,
    );

    return res.data;
  } catch (e) {
    logger.error('Could not get civit model versions by numerical id', e);
  }
};

export const getCivitModelByVersionId = async (versionId: string) => {
  try {
    const res = await axiosInstance.get<{
      air: string;
      images: { url: string }[];
    }>(`/v1/models/civit/version/${versionId}`);

    return res.data;
  } catch (e) {
    logger.error('Could not get civit version ', e);
  }
};
